/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let server operators require BeaconAuth for modded clients while allowing already-verified vanilla connections when configured.`)
};

const zh_hans1_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务器管理员可按配置要求模组客户端通过 BeaconAuth 认证，并允许已验证的原版连接。`)
};

const zh_hant1_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伺服器管理員可依設定要求模組客戶端通過 BeaconAuth 驗證，並允許已驗證的原版連線。`)
};

const fr_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les administrateurs peuvent exiger BeaconAuth pour les clients moddès tout en autorisant, selon la configuration, les connexions vanilla déjà vérifiées.`)
};

const de_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serverbetreiber können BeaconAuth für Mod-Clients verlangen und konfigurierte, bereits verifizierte Vanilla-Verbindungen zulassen.`)
};

const ja_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバー管理者は Mod クライアントに BeaconAuth を要求しつつ、設定に応じて検証済みのバニラ接続を許可できます。`)
};

const ko_card_multi_auth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서버 운영자는 모드 클라이언트에 BeaconAuth를 요구하고, 설정에 따라 이미 검증된 바닐라 연결을 허용할 수 있습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_multi_auth_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_multi_auth_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_multi_auth_desc", locale)
	if (locale === "en") return en_card_multi_auth_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_multi_auth_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_multi_auth_desc(inputs)
	if (locale === "fr") return fr_card_multi_auth_desc(inputs)
	if (locale === "de") return de_card_multi_auth_desc(inputs)
	if (locale === "ja") return ja_card_multi_auth_desc(inputs)
	return ko_card_multi_auth_desc(inputs)
};